import { TFunction } from 'i18next';

import {
  CalendarDaysIcon,
  DollarBillIcon,
  FilterIcon,
  HomeIcon,
  LocationMapIcon,
  MaleFemaleIcon,
} from 'components/Icons';

import { Demographics } from 'entities';

export const demographicsRenderer = [
  { getLabel: (t) => `${t('gender')}`, key: 'gender', Icon: MaleFemaleIcon },
  { getLabel: (t) => `${t('age')}`, key: 'age', Icon: CalendarDaysIcon },
  { getLabel: (t) => `${t('sel-income')}`, key: 'selIncome', Icon: DollarBillIcon },
  { getLabel: (t) => `${t('region')}`, key: 'region', Icon: LocationMapIcon },
  {
    getLabel: (t) => `${t('house-hold-children')}`,
    key: 'houseHoldChildren',
    Icon: HomeIcon,
  },
  { getLabel: (t) => `${t('target-filters')}`, key: 'targetFilters', Icon: FilterIcon },
] as Array<{
  getLabel: (t: TFunction) => string;
  key: keyof Demographics;
  Icon: typeof MaleFemaleIcon;
}>;

export const demographicsKeyConverter = {
  gender: 'gender',
  age: 'age',
  selIncome: 'sel-income',
  region: 'region',
  houseHoldChildren: 'house-hold-children',
  targetFilters: 'target-filters',
} as Record<keyof Demographics, string>;

export const defaultDemographics = {
  gender: '',
  age: '',
  selIncome: '',
  region: '',
  houseHoldChildren: '',
  targetFilters: '',
  quota: false,
  quotaDetails: '',
};
